import { Dialog, DialogActions, TextField, Grid, Typography, DialogTitle, DialogContent, CardContent, Button, MenuItem, CardActions } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux'; 
import { addPaymentStyle } from './style';
import Loading from '../../loading'
import DialogConfirm from '../../dialog';
import {rateUSD} from '../../../utils/setting'
import Snackbar from '../../snackbar'
function Transition(props) {
    return <Slide direction="down" {...props} />;
}
const typeArray = ['VND', 'USD']
class DialogAddPayment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openDialogs: this.props.flagOpen || false,
            payment:{
                receiveMoney: 0,
                typeMoney: 'VND',
                note: ''
            },
            content: ''
        }
        this.handleDialogOpen = this.handleDialogOpen.bind(this)
        this.handleDialogClose = this.handleDialogClose.bind(this)
    }
     // componentWillReceiveProps(nextProps) {
    //     if (this.props.booking !== nextProps.booking) {
    //         this.setState({ booking: nextProps.booking })
    //     }
    // }
    componentDidMount()
    {
        this.props.onRef(this)
    }
    handleDialogClose()
    {
        this.setState({openDialogs: false})
    }
    handleDialogOpen()
    {
        this.setState({openDialogs: true})
    }
    handleChange = e => { 
        let target = e.target;
        let {payment} = this.state
        payment[target.name] = target.value
        this.setState(payment)
    }
    addPayment = async() => { 
        this.DialogConfirm.handleDialogClose()
        this.props.add(this.state.payment)
    }
    openDialogConfirm = () => {
        let {t} = this.props
        let {payment} = this.state
        if(!payment.receiveMoney || payment.receiveMoney <= 0)
        {
            this.mSnackbar.handleClick(t('service_account_add_payment_please_enter_received_money'))
        }
        else {
            let _this = this  
            this.setState({ 
                content: 'service_account_add_payment_add_money_into_owner_account'
            }, function(){
                _this.DialogConfirm.handleDialogOpen()  
            })      
        } 
    }
    render() { 
        const { classes, t } = this.props;
        const { receiveMoney, typeMoney, note } = this.state.payment;
        let changeValueVND = (typeMoney === 'USD' ? (receiveMoney * rateUSD) : receiveMoney) + ' VND'
        return (
                <Dialog 
                    open={this.state.openDialogs}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.props.handleDialogClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description" 
                    classes={{
                        paperWidthSm: classes.paperWidthSm,
                    }}
                >     
                    <Snackbar onRef={snackbar => (this.mSnackbar = snackbar)} />
                    <Loading onRef={id => (this.loading = id)}/>
                       <DialogConfirm
                            onRef={dialog => (this.DialogConfirm = dialog)} 
                            disagree={t("service_account_add_payment_dialog_cancel")} 
                            agree={t("service_account_add_payment_dialog_ok")}
                            title={t("service_account_add_payment_dialog_confirm")}
                            content={t(this.state.content)}
                            action={this.addPayment}
                        />
                        <DialogTitle>
                            <Typography variant="h3" gutterBottom className={classes.titlePayment}>
                            {t('service_account_add_payment')}
                            </Typography>
                        </DialogTitle>
                        <DialogContent className={classes.DialogContent}> 
                            <Grid container spacing={16}>  
                                <Grid item xs={12} sm={12}>
                                    <TextField 
                                        select 
                                        className= {classes.TextField}
                                        label={t('service_account_add_payment_type_money')}
                                        placeholder={t('pls_select')} 
                                        fullWidth
                                        value={typeMoney}
                                        onChange={this.handleChange} 
                                        name="typeMoney"
                                        SelectProps={{ 
                                            MenuProps: {
                                                className: classes.menu,
                                            },
                                        }}
                                        
                                        // helperText="Please select your currency"
                                        margin="normal"
                                        variant="outlined"
                                    >
                                        {typeArray.map((type, index) => { 
                                                return (
                                                <MenuItem key={index} value={type}>
                                                    {t(type)}
                                                </MenuItem> 
                                                )
                                        })}  
                                    </TextField> 
                                </Grid>  
                                <Grid item xs={12} sm={12}>
                                    <TextField
                                        label={t("service_account_add_payment_received_money")}
                                        className= {classes.TextField}
                                        name="receiveMoney"
                                        margin="normal"
                                        type="number"
                                        
                                        fullWidth
                                        value={receiveMoney}
                                        onChange={this.handleChange}
                                        fullWidth 
                                        variant="outlined" 
                                    />
                                </Grid> 
                                <Grid item xs={12} sm={12}>
                                    <TextField
                                            disabled = {true}
                                            label={t("service_account_add_payment_received_money_to_VND")}
                                            className= {classes.TextField} 
                                            margin="normal" 
                                            
                                            fullWidth
                                            value={changeValueVND} 
                                            fullWidth 
                                            variant="outlined" 
                                    />
                                </Grid>  
                                <Grid item xs={12} sm={12}>
                                    <TextField
                                        label={t("service_account_add_payment_note")}
                                        className= {classes.TextField}
                                        name="note"
                                        margin="normal" 
                                        multiline
                                        rows={3}
                                        
                                        fullWidth
                                        value={note}
                                        onChange={this.handleChange}
                                        fullWidth 
                                        variant="outlined" 
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent> 
                        <DialogActions classes={{ root: classes.DialogActions }}>
                            {/* <IconButton  aria-label="Close"  size="small" 
                                className={classes.marginCloseButton}
                                onClick={this.props.handleDialogClose}
                            > */}
                            <Button variant="contained" color="default" className={classes.button} onClick={()=>this.handleDialogClose()}>
                                {t('service_account_add_payment_close')} 
                            </Button>
                            <Button variant="contained" color="primary" className={classes.button} onClick={()=>this.openDialogConfirm()}>
                                {t('service_account_add_payment')} 
                            </Button>
                            {/* <CloseIcon fontSize="small" /> */}
                            {/* </IconButton > */}
                        </DialogActions>  
                </Dialog>

        );
    }
}


// Dialog.propTypes = {
//     classes: PropTypes.object.isRequired,
//     theme: PropTypes.object.isRequired,
// };
const mapState = state => ({ 
});

const mapDispatch = dispatch => ({ 
    addPayment: dispatch.serviceAccount.addPayment,
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(addPaymentStyle, { withTheme: false })(DialogAddPayment)));
